export default __webpack_public_path__ + "static/media/Girdle of the Earth Mother.54208c08.jpg";